import React from 'react';
import { render } from 'react-dom';
import Cuts from './apps/CutsRedesign/Cuts';

// Beef Cuts redesign (B01-1001) — production preview app, mounted on its own
// element so it runs in parallel with the existing /cuts page.
const el = document.getElementById('cuts-redesign-app');
if (el) render(<Cuts {...el.dataset} />, el);
